import React, { FC } from 'react';
import { Link } from 'gatsby';
import * as styles from '@/newcar/ui/contract/components/Header/index.module.styl';

import { ContractType } from '@/newcar/util/const/contract';

import carmo3Logo from '@/newcar/ui/common/img/logo/carmo3-logo.svg';

interface HeaderProps {
  type?: ContractType;
}

// 申込みフォーム用のヘッダー
const Header: FC<HeaderProps> = ({ type }) => {
  const getHeadLogo = () => (
    <>
      <h1 className={styles.carmoLogo}><img src={carmo3Logo} alt="カルモスリー" width="150" /></h1>
    </>
  );
  // 完了ページのみTOPへのリンクつき
  return (
    <header className={`${styles.headerShadow}`}>
      <nav className="navbar level is-margin-bottom-0" role="navigation" aria-label="main navigation" id="form-header">
        <div className="navbar-brand level-item has-text-centered">
          { type !== 'provisional_completion'
            ? (
              <span className="columns is-mobile is-vcentered">
                {getHeadLogo()}
              </span>
            )
            : (
              <Link to="/" className="columns is-mobile is-vcentered">
                {getHeadLogo()}
              </Link>
            )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
